/**
 * Class for the IWM application domain context. The domain is the category
 * (i.e. Account, Household, etc).
 * The value is the object that contains fields depending on the domain
 * (i.e. for account domain, it may contain accountNumber. for group domain,
 * it may contain groupName, groupSourceCode, etc).
 */
export class DomainContext<T> {
    domain: string;
    value: T;
}

export class AccountContextValue {
    constructor(public accountNumber: string, public accountName?: string, public ibd?: string,
                public off?: string, public ip?: string, public categoryCode?: string, public accountType?: string,
                public status?: string, public custodianCode?: string, public businessPurposeCode?: string,
                public internalIdentifier?: string, public isInternalCustody?: string,
                public hashValue?: string, public accessCategoryCd?: string, public shortName?: string) {}
}

export class BusinessParty {
    constructor(public businessId: string, public businessName: string) { }
}

export class AdvisorContextValue {
    constructor(public advisorId: string, public advisorName?: string, public roleCode?: string,
                public businessParty?: BusinessParty, public hashValue?: string) { }
}

export class GroupContextValue {
    constructor(public groupId: string, public groupDescription?: string, public groupSourceCode?: string, public numberOfAccounts?: string,
                public groupType?: string, public accessType?: string, public albridgeIndicator?: string,
                public internalIdentifier?: string, public brokerId?: string, public groupCreatorId?: string,
                public groupGUID?: string, public hashValue?: string) {}
}

// Currently the Household and Group contexts are the same as they will both make a call to groups api
export class HouseholdContextValue {
    constructor(public groupId: string, public groupDescription?: string, public groupSourceCode?: string, public numberOfAccounts?: string,
                public groupType?: string, public accessType?: string, public albridgeIndicator?: string,
                public internalIdentifier?: string,
                public brokerId?: string, public groupCreatorId?: string, public groupGUID?: string, public hashValue?: string) {}
}

export class ClientContextValue {
    constructor(public clientId: string, public clientName?: string,  public status?: string,  public ibd?: string,  public off?: string,
                public ip?: string, public internalIdentifier?: string, public affiliateClientId?: string, public hashValue?: string) {}
}

export class IbdOffIpContextValue {
    public ibdOffIp: string;
    constructor(public ibd: string, public off: string, public ip: string, public ibdName?: string, public ipName?: string,
                public hashValue?: string) {
        this.ibdOffIp = this.ibd + this.off + this.ip;
    }
}

export class SecurityContextValue {
    constructor(public symbol: string, public cusip?: string, public description?: string, public type?: string, public subType?: string,
                public divReinvestEligibility?: string, public nonDollarInd?: string, public marketExchange?: string,
                public hashValue?: string) {}
}

export class UserContext {
    constructor(public lastName?: string, public rrInd?: string, public lastLoginTS?: string, public brokerType?: string,
                public totalCount?: number, public ibdIdList?: string[], public sso?: boolean, public ofcNum?: string,
                public introducingFirm?: string, public customerType?: string, public introducingFirmIndicator?: boolean,
                public ibdId?: string, public internalUser?: boolean, public smartflowSubscriptionInd?: string,
                public custodianCode?: boolean, public ibdName?: string, public ipCount?: number, public accountCount?: number,
                public billingCorrNum?: string, public ip?: string, public ibdListEligibilityInd?: string,
                public officeInd?: string, public ipName?: string, public itemCount?: number, public firstName?: string,
                public ibdInd?: string, public groupCount?: number, public daysToExpire?: string, public middleName?: string,
                public ibdIdCount?: string, public averagePriceAccountInd?: string, public userStatusComplete?: boolean,
                public preference?: UserPreference, public viewProspectusClientId?: string, public brokerTypeCode?: string,
                public brokerTypeLegacy?: string ) {}
}

export class UserPreference {
    constructor(public landingPage?: string, public locale?: string, public timeZone?: string,
                public currency?: string, public theme?: string) {}
}
